exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.scheduler-body[data-v-8888eb08] {\n  display: flex;\n  flex-direction: row;\n  flex-grow: 1;\n}\n.scheduler-body > div[data-v-8888eb08]:first-child {\n    width: 250px;\n    border: 1px solid grey;\n}\n.scheduler-body > div[data-v-8888eb08]:last-child {\n    flex-grow: 1;\n    position: relative;\n}\n.room-edit-field[data-v-8888eb08] {\n  margin: 8px 12px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8888eb08","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["/usr/src/app/src/assets/_include-media.scss","/usr/src/app/src/assets/palette.scss"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/event/schedule.vue
// module id = 2oC0
// module chunks = 1